var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71117 7.09579C5.06458 7.31183 5.17595 7.77346 4.95991 8.12687C4.19368 9.38034 3.75 10.8527 3.75 12.4285C3.75 16.9815 7.44707 20.6785 12 20.6785C12.4142 20.6785 12.75 21.0143 12.75 21.4285C12.75 21.8428 12.4142 22.1785 12 22.1785C6.61864 22.1785 2.25 17.8099 2.25 12.4285C2.25 10.5672 2.77489 8.82535 3.68009 7.34453C3.89613 6.99112 4.35776 6.87975 4.71117 7.09579Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.25C4.41421 2.25 4.75 2.58579 4.75 3V7.25H9C9.41421 7.25 9.75 7.58579 9.75 8C9.75 8.41421 9.41421 8.75 9 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8V3C3.25 2.58579 3.58579 2.25 4 2.25Z",
    fill: "#265EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68021 7.34416C5.39235 4.54627 8.47973 2.67847 11.9999 2.67847C17.3858 2.67847 21.7499 7.04734 21.7499 12.4285C21.7499 17.8096 17.3858 22.1785 11.9999 22.1785C11.5857 22.1785 11.2499 21.8427 11.2499 21.4285C11.2499 21.0143 11.5857 20.6785 11.9999 20.6785C16.5569 20.6785 20.2499 16.9816 20.2499 12.4285C20.2499 7.8753 16.5569 4.17847 11.9999 4.17847C9.02299 4.17847 6.41037 5.75642 4.95966 8.1271C4.74345 8.48041 4.28177 8.59156 3.92846 8.37536C3.57515 8.15915 3.464 7.69747 3.68021 7.34416Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.6d014c909ead193a586eed56e085f88a.svg";
export { ForwardRef as ReactComponent };